<template>
  <div>
    <!-- main-area -->
    <main class="fix">
      <!-- breadcrumb-area -->
      <section class="breadcrumb__area breadcrumb__bg">
        <div class="container">
          <div class="row mt-5">
            <div class="col-lg-6">
              <div class="breadcrumb__content">
                <h2 class="title">Berita</h2>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);" @click="$router.push('/')">Beranda</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Berita</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div class="breadcrumb__shape">
          <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
        </div>
      </section>
      <!-- breadcrumb-area-end -->
      <!-- blog-area -->
      <section class="blog_area mt-5">
        <div class="container">
          <div class="blog__inner-wrap">
            <div class="row">
              <div class="col-70">
                <div class="blog-post-wrap">
                  <div class="row gutter-24">
                    <div class="col-md-6" v-for="data in list_data" :key="data.id">
                      <div class="blog__post-two shine-animate-item">
                        <div class="blog__post-thumb-two">
                          <a href="javascript:void(0);" class="shine-animate">
                            <img :src="file_path + data.foto" alt="Apexa" />
                          </a>
                        </div>
                        <div class="blog__post-content-two">
                          <div class="blog-post-meta">
                            <ul class="list-wrap">
                              <li>
                                <a href="javascript:void(0);" class="blog__post-tag-two">{{ data.kategori_id }}</a>
                              </li>
                              <li><i class="fas fa-calendar-alt"></i>{{ UMUM.tglConvert(data.createAt) }}</li>
                            </ul>
                          </div>
                          <h2 class="title">
                            <a @click="push_berita(data.id)" href="javascript:void(0);">{{ data.judul }}</a>
                          </h2>
                          <div class="blog-avatar">
                            <div class="avatar-content">
                              <p>By <a href="javascript:void(0);">{{ data.createBy }}</a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pagination-wrap mt-40">
                    <nav aria-label="Page navigation example">
                      <ul class="pagination list-wrap">
                        <li class="page-item">
                          <a class="page-link" href="javascript:void(0);" @click="btn_prev" id="pref"><i class="fas fa-angle-double-left"></i></a>
                        </li>
                        <!-- <li class="page-item active"><a class="page-link" href="#">1</a></li> -->
                        <li class="page-item"><a class="page-link" href="javascript:void(0);">{{ page_first }}</a></li>
                        <li class=""><a class="page-link border-0" href="javascript:void(0);">-</a></li>
                        <li class="page-item"><a class="page-link" href="javascript:void(0);">{{ page_last }}</a></li>
                        <li class="page-item next-page">
                          <a class="page-link" href="javascript:void(0);" @click="btn_next"><i class="fas fa-angle-double-right"></i></a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <hr>
            <!-- <br>
            <div class="text-center">
                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                    <i class="fa fa-arrow-circle-o-left" aria-hidden="true" style="font-size:150%"></i>
                </button>
                &nbsp;
                <span style="font-size: 85%; color: #a5a5a5">
                    <b>{{page_first}} - {{page_last}}</b>
                </span>
                &nbsp;
                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                    <i class="fa fa-arrow-circle-o-right" aria-hidden="true" style="font-size:150%"></i>
                </button>
            </div>
            <br>
        <hr> -->
                </div>
              </div>
              <div class="col-30">
                <aside class="blog__sidebar">
                  <div class="sidebar__widget sidebar__widget-two">
                    <div class="sidebar__search">
                      <form href="javascript:void(0);">
                        <input v-model="cari_value" @keyup="cari_data()" type="text" placeholder="Cari . . ." />
                        <button class="javascript:void" type="submit">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                            <path
                              d="M19.0002 19.0002L14.6572 14.6572M14.6572 14.6572C15.4001 13.9143 15.9894 13.0324 16.3914 12.0618C16.7935 11.0911 17.0004 10.0508 17.0004 9.00021C17.0004 7.9496 16.7935 6.90929 16.3914 5.93866C15.9894 4.96803 15.4001 4.08609 14.6572 3.34321C13.9143 2.60032 13.0324 2.01103 12.0618 1.60898C11.0911 1.20693 10.0508 1 9.00021 1C7.9496 1 6.90929 1.20693 5.93866 1.60898C4.96803 2.01103 4.08609 2.60032 3.34321 3.34321C1.84288 4.84354 1 6.87842 1 9.00021C1 11.122 1.84288 13.1569 3.34321 14.6572C4.84354 16.1575 6.87842 17.0004 9.00021 17.0004C11.122 17.0004 13.1569 16.1575 14.6572 14.6572Z"
                              stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </button>
                      </form>
                    </div>
                  </div>
                  <div class="sidebar__widget">
                    <h4 class="sidebar__widget-title">Berita Terbaru</h4>
                    <div class="sidebar__post-list">
                      <div class="sidebar__post-item" v-for="data in list_data" :key="data.id">
                        <div class="sidebar__post-thumb">
                          <a href="javascript:void(0);" @click="push_berita(data.id)"><img :src="file_path+data.foto" alt="Apexa" /></a>
                        </div>
                        <div class="sidebar__post-content">
                          <h5 class="title"><a href="javascript:void(0);" @click="push_berita(data.id)">{{ data.judul }}</a></h5>
                          <span class="date"><i class="flaticon-time"></i>{{ UMUM.tglConvert(data.createAt) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- blog-area-end -->
    </main>
    <!-- main-area-end -->
  </div>
</template>

<script>
import UMUM from '../../library/umum'

export default {

  data() {
    return {
      data_load: false,
      data_load: false,
      form: {
        id: '',
        judul: '',
        sumber: '',
        deskripsi: '',
        isi: '',
        foto: '',
        unit_kerja: '',
        status: '',
        keterangan: '',
        createBy: '',
        createAt: '',
      },
      id: '',
      cek_load_data: true,
      file_old: "",
      file_path: this.$store.state.url.URL_APP + "uploads/",

      unit_kerja: UNIT_KERJA,

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
      UMUM: UMUM,
    }
  },
  methods: {
    getView: function () {
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_BERITA + "viewOPD", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          unit_kerja: this.unit_kerja
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          this.cek_load_data = false;
          // console.log(res_data);
        });
    },
    getListBerita: function () {
      fetch(this.$store.state.url.URL_BERITA + "viewOPD", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          unit_kerja: this.unit_kerja
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          // console.log(res_data);
        });
    },
    push_berita: function (id) {
      this.$router.push('/isiBerita?id=' + id);
    },


    // ================== PAGINASI ====================
    alertku: function (type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {

      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },
    // ================== PAGINASI ====================













  },
  mounted() {
    this.getView();
    this.getListBerita();
  },

}
</script>

<style></style>